import script from "./TheSignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSignUp.vue?vue&type=script&setup=true&lang=js"

import "./TheSignUp.vue?vue&type=style&index=0&id=5cae51ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cae51ae"]])

export default __exports__